export default __webpack_public_path__ + "static/media/flag_planet_earth.be591e4a.svg";